module.exports = __webpack_public_path__ + "assets/img/assistant-module2.8ae5143f.png";